import { totalScore, type SchrijvenScore } from "../domain/schrijven";

export type SchrijvenBand = "pass" | "warn" | "fail";

export interface SchrijvenCriterion {
  key: keyof SchrijvenScore;
  label: string;
  max: number;
  notes: string;
}

export const SCHRIJVEN_RUBRIC: readonly SchrijvenCriterion[] = [
  { key: "execution",  label: "Uitvoering",   max: 3, notes: "Bullet coverage gate — 0 auto-zeros the rest" },
  { key: "grammar",    label: "Grammatica",   max: 2, notes: "A2 is forgiving" },
  { key: "spelling",   label: "Spelling",     max: 2, notes: "Personal details must be exact" },
  { key: "clearness",  label: "Structuur",    max: 1, notes: "en / maar / want / omdat earns it" },
  { key: "vocabulary", label: "Woordenschat", max: 2, notes: "Reasonably diverse for 2" },
] as const;

export function bandFor(s: SchrijvenScore): SchrijvenBand {
  if (s.execution === 0) return "fail";
  const total = totalScore(s);
  if (total >= 8 && s.execution >= 2) return "pass";
  if (total >= 8 && s.execution < 2) return "warn";
  if (total >= 5) return "warn";
  return "fail";
}

export const BAND_LABEL: Record<SchrijvenBand, string> = {
  pass: "Voldoende",
  warn: "Onvolledig",
  fail: "Onvoldoende",
};
